module.exports = __webpack_public_path__ + "media/images/hamas-about-section2-1339a8d0648baf1c06920225345a7c3f.png";